import ConfirmBooking from "./ConfirmBooking";

export default ConfirmBooking;
